import React from 'react';
import { useNavigate } from 'react-router-dom';
import Card from '../ui/Card';
import Button from '../ui/Button';
import { useAuth } from '../../services/AuthContext';

// MVP: só o trial está disponível. Os planos pagos aparecem como "Em breve"
// porque a integração com o Mercado Pago ainda não foi definida, e os preços
// tambem nao. Ficam visíveis de propósito, para sinalizar que o produto será
// pago — mas sem botão clicável, já que não há para onde levar.
//
// Quando o pagamento entrar: reativar os botões, preencher os preços aqui e no
// seed do banco (supabase/seed.sql), e apontar para a rota de checkout. Os ids
// abaixo são os mesmos de public.plans e precisam continuar batendo.
const PAGAMENTO_DISPONIVEL = false;

const PricingSection = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  const iniciarTrial = () => {
    navigate(user ? '/dashboard' : '/signup');
  };

  const planos = [
    {
      id: 1,
      nome: 'Avaliação',
      descricao: '30 dias para testar o plugin por completo',
      preco: 'Grátis',
      intervalo: '/30 dias',
      recursos: [
        'Acesso completo ao plugin',
        'Todos os comandos liberados',
        'Suporte por e-mail',
        'Sem cartão de crédito',
      ],
      variant: 'featured',
      destaque: true,
      disponivel: true,
    },
    {
      id: 2,
      nome: 'Pro Mensal',
      descricao: 'Para uso contínuo, com renovação mensal',
      preco: null,
      intervalo: '/mês',
      recursos: [
        'Tudo do plano de avaliação',
        'Atualizações contínuas',
        'Suporte por e-mail',
      ],
      variant: 'subtle',
      disponivel: false,
    },
    {
      id: 3,
      nome: 'Pro Anual',
      descricao: 'Melhor custo-benefício para uso constante',
      preco: null,
      intervalo: '/ano',
      recursos: [
        'Tudo do plano mensal',
        'Desconto no valor anual',
        'Suporte prioritário',
      ],
      variant: 'subtle',
      disponivel: false,
    },
  ];

  return (
    <section id="planos" className="py-20 lg:py-24 bg-rn-surface">
      <div className="container mx-auto px-6">
        <div className="text-center mb-12">
          <p className="eyebrow text-rn-orange-text mb-3">Planos</p>
          <h2 className="text-[27px] md:text-[32px] font-semibold mb-4 text-rn-navy">
            Comece grátis por 30 dias
          </h2>
          <p className="text-rn-text-soft max-w-xl mx-auto">
            Crie sua conta, confirme o e-mail e o plugin libera na hora. Sem
            cartão de crédito. Os planos pagos chegam em breve.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 items-stretch">
          {planos.map((plano) => {
            const escuro = plano.variant === 'featured';
            return (
            <Card
              key={plano.id}
              variant={plano.variant}
              className="relative p-8 flex flex-col"
            >
              {plano.destaque && (
                <div className="absolute top-0 right-0 -translate-y-1/2 px-3 py-1 bg-rn-orange text-rn-navy text-sm font-semibold rounded-full">
                  Disponível agora
                </div>
              )}

              <h3 className="text-2xl font-semibold mb-2">{plano.nome}</h3>
              <p className={`mb-4 ${escuro ? 'text-rn-text-soft-dk' : 'text-rn-text-soft'}`}>{plano.descricao}</p>

              <div className="mb-6">
                {plano.preco ? (
                  <>
                    <span className="text-4xl font-semibold">
                      {plano.preco}
                    </span>
                    <span className={escuro ? 'text-rn-text-soft-dk' : 'text-rn-text-soft'}>{plano.intervalo}</span>
                  </>
                ) : (
                  <span className={`text-2xl font-semibold ${escuro ? 'text-rn-text-soft-dk' : 'text-rn-text-soft'}`}>
                    Em breve
                  </span>
                )}
              </div>

              <ul className="space-y-4 mb-8 flex-grow">
                {plano.recursos.map((recurso, i) => (
                  <li key={i} className="flex items-center">
                    <svg
                      className={`h-5 w-5 mr-3 ${
                        plano.disponivel ? 'text-green-500' : 'text-gray-300'
                      }`}
                      fill="none"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path d="M5 13l4 4L19 7" />
                    </svg>
                    <span>{recurso}</span>
                  </li>
                ))}
              </ul>

              {plano.disponivel ? (
                <Button variant="primary" className="w-full" onClick={iniciarTrial}>
                  {user ? 'Ir para o painel' : 'Criar conta grátis'}
                </Button>
              ) : (
                <Button
                  variant="secondary"
                  className="w-full"
                  disabled={!PAGAMENTO_DISPONIVEL}
                  title="Disponível em breve"
                >
                  Em breve
                </Button>
              )}
            </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
